import { useFormik } from 'formik';
import { FraudTypeParamsDataProps } from './props';
import { useEffect } from 'react';

export const useFraudTypeData = ({ data }: FraudTypeParamsDataProps) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            active: false,
            extra: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active || false);
        formik?.setFieldValue('extra', data?.extra || '');
    }, [data]);

    return {
        formik,
    };
};
